var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69569 0.931097C6.82631 1.79569 7.04246 3.60801 6.15293 5.1543C5.2634 6.7006 3.57577 7.41555 2.27057 6.86687C1.92972 6.72554 1.62212 6.56758 1.26465 6.35975L3.01046 3.34198L4.75628 0.324219C5.11375 0.52374 5.40472 0.714949 5.69569 0.931097Z",
    fill: "url(#paint0_linear_226_2639)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77051 1.28076C6.73487 2.01234 6.9427 3.59189 6.21944 4.94697C5.54605 6.21061 4.29073 6.85905 3.22661 6.56808C2.55323 6.75098 1.86321 6.7011 1.26465 6.36025C1.62212 6.56808 1.92972 6.71773 2.27057 6.86737C3.57577 7.41605 5.2634 6.7011 6.15293 5.15481C7.04246 3.60851 6.82631 1.79619 5.69569 0.939911C5.40472 0.71545 5.12207 0.524241 4.76459 0.316406C5.12207 0.524241 5.40472 0.81521 5.61256 1.15606C5.66244 1.19763 5.72063 1.23919 5.77051 1.28076Z",
    fill: "url(#paint1_radial_226_2639)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95656 0.455704C6.23683 1.1956 6.51948 3.10768 5.58838 4.72048C4.65728 6.33328 2.86159 7.04823 1.58132 6.30834C0.301059 5.56845 0.0100896 3.65636 0.941191 2.03525C1.87229 0.42245 3.66799 -0.284189 4.95656 0.455704Z",
    fill: "#FCD555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75668 0.316444C6.11177 1.0979 6.42768 3.08481 5.46332 4.7558C4.49897 6.4268 2.62014 7.14175 1.26505 6.36029C-0.09003 5.57883 -0.405939 3.59192 0.558415 1.92093C1.52277 0.249937 3.4016 -0.465016 4.75668 0.316444Z",
    fill: "url(#paint2_radial_226_2639)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3615 5.77913C3.34487 5.85395 3.27005 5.92046 3.17861 5.9454C3.09547 5.97034 3.01234 5.95371 2.96246 5.91215C2.5551 6.00359 2.14774 5.97865 1.77364 5.80407C0.701212 5.30527 0.352049 3.7756 0.992181 2.39558C1.34134 1.63906 1.92328 1.08206 2.54679 0.81603C2.5551 0.724583 2.62992 0.641449 2.738 0.616508C2.83776 0.591568 2.93752 0.616508 2.99571 0.683016C3.13704 0.658075 3.28668 0.641449 3.42801 0.641449C3.46126 0.591568 3.52777 0.566628 3.60259 0.583255C3.66078 0.599882 3.71066 0.633135 3.72729 0.683016C3.8603 0.707956 3.98501 0.749523 4.10971 0.807717C5.18214 1.30652 5.5313 2.83619 4.89117 4.22453C4.542 4.9561 3.97669 5.50479 3.3615 5.77913Z",
    fill: "#191919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29033 0.932683C5.30456 1.51462 5.5124 3.0526 4.76419 4.34949C4.01599 5.6547 2.57777 6.23663 1.57185 5.6547C0.557612 5.07276 0.349777 3.53478 1.09798 2.23789C1.84619 0.932683 3.27609 0.350745 4.29033 0.932683Z",
    fill: "url(#paint3_radial_226_2639)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64714 2.75297C2.36209 1.52259 3.71717 0.965588 4.67322 1.52259C4.81454 1.60572 4.93093 1.69717 5.03901 1.81355C4.88936 1.43945 4.63165 1.14017 4.2908 0.940647C3.27656 0.358709 1.84666 0.940647 1.09014 2.23754C0.341933 3.53443 0.558081 5.0641 1.57232 5.65435C1.64714 5.69591 1.72196 5.72917 1.79678 5.76242C1.10677 5.10566 1.01532 3.84202 1.64714 2.75297Z",
    fill: "url(#paint4_radial_226_2639)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43099 2.4278C2.121 1.23067 3.37632 0.640414 4.36562 0.99789C4.39887 1.0062 4.43213 1.02283 4.45707 1.03114C4.43213 1.01452 4.40719 0.989577 4.37393 0.97295C4.34899 0.956323 4.32405 0.939696 4.2908 0.923069C3.27656 0.341131 1.84666 0.923069 1.09014 2.21996C0.341933 3.53348 0.558081 5.06314 1.57232 5.6534C1.59726 5.67002 1.63051 5.68665 1.65545 5.69496C1.6887 5.71159 1.71364 5.72822 1.7469 5.73653C1.72196 5.7199 1.69702 5.69496 1.67208 5.67834C0.857364 5.00495 0.740976 3.61661 1.43099 2.4278Z",
    fill: "url(#paint5_linear_226_2639)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65148 0.898129C3.89257 0.881502 4.13365 0.914756 4.35812 0.99789C4.39137 1.0062 4.42462 1.02283 4.44956 1.03114C4.42462 1.01452 4.39968 0.989577 4.36643 0.97295C4.34149 0.956323 4.31655 0.939696 4.2833 0.923069C3.26906 0.341131 1.83916 0.923069 1.08264 2.21996C0.342743 3.53348 0.558891 5.06314 1.57313 5.6534C1.59807 5.67002 1.63132 5.68665 1.65626 5.69496C1.68951 5.71159 1.71445 5.72822 1.74771 5.73653C1.72277 5.7199 1.69783 5.69496 1.67289 5.67834C1.54819 5.57858 1.44011 5.45387 1.34866 5.32086C0.600458 4.69735 0.475757 3.40046 1.09926 2.28647C1.68951 1.21404 2.76194 0.665354 3.65148 0.898129Z",
    fill: "url(#paint6_radial_226_2639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_2639",
    x1: 2.83782,
    y1: 7.26682,
    x2: 6.32715,
    y2: 1.22311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#F8941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_226_2639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.39688 3.00922) scale(4.75545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6543,
    stopColor: "#E4D9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#B3984C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_226_2639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.76161 0.192949) scale(6.09797 6.09797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_226_2639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0065479 -0.410463) scale(7.45114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68A1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_226_2639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.16173 3.86039) scale(4.30474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6694,
    stopColor: "#FFE1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA74F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_226_2639",
    x1: 0.734816,
    y1: 5.16988,
    x2: 3.41819,
    y2: 0.522139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67024"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_226_2639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.23904 4.04129) scale(4.17315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6543,
    stopColor: "#E4D9C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#B3984C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.dbe8b34307c822f0a77a59036d220223.svg";
export { ForwardRef as ReactComponent };